// extracted by mini-css-extract-plugin
module.exports = {"desktop":"_type_desktop__24XkX","tablet":"_type_tablet__1BwYO","mobile":"_type_mobile__1y1Vw","center":"_type_center__2O3QC"};